import React from 'react';
const ColorSwatch = ({ variation, stroke, ariaHidden }) => {
    if (!variation) {
        return React.createElement(React.Fragment, null);
    }
    return (React.createElement("i", { className: `swatch swatch--${variation.refinementColor}`, title: variation.displayValue, style: { backgroundColor: variation.swatchColor, backgroundImage: (variation.swatchImg && `url(${variation.swatchImg})`) || undefined }, "aria-hidden": ariaHidden }, stroke && React.createElement("span", { className: "stroke" })));
};
export default ColorSwatch;
